<template>
    <form-row :title="user_is_attorney ? 'Has the buyer signed <br>their property disclosures?' : 'Have you signed <br>your property disclosures?'">
        <input-radio-boolean
            name="has_signed_disclosures"
            :value="attorney.has_signed_disclosures"
            true="Yes"
            false="No"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        attorney: {},
        read_only: { default: false },
        user_is_attorney: { default: false },
    },
}
</script>
